import { render } from "./NumberRecordView.vue?vue&type=template&id=29477e42&scoped=true"
import script from "./NumberRecordView.vue?vue&type=script&lang=js"
export * from "./NumberRecordView.vue?vue&type=script&lang=js"

import "./NumberRecordView.vue?vue&type=style&index=0&id=29477e42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29477e42"]])

export default __exports__